/* Zemulo: review numbers counted from the reviews on the page, and the sticky add-to-cart bar. */
(function () {
  function reviewStats() {
    var n = 0;
    var sum = 0;
    var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    document.querySelectorAll('.zr__card .zr__stars[data-rating]').forEach(function (el) {
      var r = parseInt(el.getAttribute('data-rating'), 10);
      if (!r) return;
      n += 1;
      sum += r;
      dist[r] += 1;
    });
    return n ? { n: n, avg: sum / n, dist: dist } : null;
  }

  function fillReviews() {
    var s = reviewStats();
    if (!s) return;
    var avg = (Math.round(s.avg * 100) / 100).toString();
    document.querySelectorAll('[data-z-avg]').forEach(function (el) { el.textContent = avg; });
    document.querySelectorAll('[data-z-count]').forEach(function (el) { el.textContent = s.n; });
    document.querySelectorAll('[data-z-bar]').forEach(function (el) {
      var p = Math.round((s.dist[el.getAttribute('data-z-bar')] * 100) / s.n);
      el.style.width = p + '%';
      var label = el.parentElement.parentElement.querySelector('[data-z-pct]');
      if (label) label.textContent = p + '%';
    });
  }

  function stickyBar() {
    var form = document.getElementById('zbundle-form');
    if (!form) return;
    var cta = form.querySelector('.zb2-cta');
    if (!cta) return;
    var bar = document.createElement('div');
    bar.className = 'z-sticky';
    bar.innerHTML =
      '<img alt="" src="" width="46" height="46">' +
      '<div class="z-sticky__t"><b>המשאבה במתנה</b><span class="z-sticky__s"></span> · <span class="z-sticky__p"></span></div>' +
      '<button type="button" class="z-sticky__b">הוספה לסל ←</button>';
    document.body.appendChild(bar);
    document.body.classList.add('z-has-sticky');

    function sync() {
      var input = form.querySelector('.zb2-card input:checked');
      var card = input && input.closest('.zb2-card');
      if (!card) return;
      var img = card.querySelector('.zb2-img');
      if (img) { var bi = bar.querySelector('img'); bi.src = img.currentSrc || img.src; bi.alt = img.alt || 'החבילה שנבחרה'; }
      var t = card.querySelector('.zb2-t');
      var p = card.querySelector('.zb2-p');
      bar.querySelector('.z-sticky__s').textContent = t ? t.textContent.trim() : '';
      bar.querySelector('.z-sticky__p').textContent = p ? p.textContent.trim() : '';
    }
    form.addEventListener('change', sync);
    sync();

    bar.querySelector('button').addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(cta);
      else cta.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-on', !e.isIntersecting);
        });
      }).observe(cta);
    } else {
      bar.classList.add('is-on');
    }

    // Body flag for the floating WhatsApp button: on mobile it stays hidden until the buy box is scrolled past
    var ticking = false;
    function past() {
      ticking = false;
      document.body.classList.toggle('z-past-cta', cta.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(past); }
    }, { passive: true });
    past();
  }

  function start() {
    fillReviews();
    stickyBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
